<template>
	<el-input size="mini" type="text" :disabled="disabled" v-model="money" @input="onInput" @change="change" :placeholder="$t(placeholder)" ref="money" @focus="$emit('focusCallback')" @blur="blur" @keyup.enter.native="$emit('enterEvent')">
		<template v-if="suffix && suffix.tag === 'span'">
			<span slot="suffix">{{ suffix.content }}</span>
		</template>
		<template v-if="prefix && prefix.tag === 'span'">
			<span slot="prefix">{{ prefix.content }}</span>
		</template>
	</el-input>
</template>

<script>
import { regexMoneyNumber } from '~/common/utils/validate';
import { storage } from '~/common//utils/storage';
export default {
  props: {
    value: {
      type: [String, Boolean, Number, null],
      required: true,
      default: ''
    },
    currencyId: {
      type: [String, Number],
      default: '8'
    },
    suffix: {
      type: Object
    },
    prefix: {
      type: Object
    },
    placeholder: {
      type: String,
      required: false,
      default: 'portal.qing-shu-ru-jin-e'
    },
    useOrigin: {
      //使用原始值，不做精度处理
      type: Boolean,
      default: false
    },
    initRormat: {
      //初始化展示，做精度处理展示
      type: Boolean,
      default: false
    },
    disabled: {
      //初始化展示，做精度处理展示
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      money: '',
      data: '',
      newVal: ''
    };
  },
  created() {
    this.getCurrencyInfo();
  },
  watch: {
    value(val) {
      if (!val && val !== 0) {
        this.money = '';
      } else {
        if (!this.useOrigin && regexMoneyNumber(val)) {
          //还原为，不带精度的数据
          this.money = val / Math.pow(10, this.data.decimals || 4);
        }
      }
    },
    currencyId() {
      this.getCurrencyInfo();
    }
  },
  methods: {
    focus() {
      this.$refs.money.focus();
    },
    getCurrencyInfo() {
      const cid = this.currencyId === '0' || !this.currencyId ? '8' : this.currencyId;
      this.data = storage.get('currency').filter(({
        id
      }) => id === cid)?.[0];
      if (regexMoneyNumber(this.value)) {
        if (this.initRormat) {
          if (this.newVal) {
            this.money = this.newVal;
          } else {
            this.money = this.value ? parseFloat((parseFloat(this.value) / Math.pow(10, this.data.decimals)).toFixed(this.data.decimals)) : 0;
          }
        } else if (this.useOrigin) {
          this.money = this.value;
        } else {
          this.money = this.value ? parseFloat((parseFloat(this.value) / Math.pow(10, this.data.decimals)).toFixed(this.data.decimals)) : 0;
        }
      } else {
        this.money = this.value;
      }

      //不用这个接口获取币种信息了，这个方法在created阶段有调用，子组件一有更新，反复调用此接口，页面加载慢很多		
      // this.$axios.$get(`rest/store/general/v3/currencies/GetCurrencyDetailInfoByID/${this.currencyId === '0' || !this.currencyId ? 8 : this.currencyId}`).then(({ data, code }) => {
      // 	if (code !== 200) return;
      // 	if (data) {
      // 		this.data = data;
      // 		if (regexMoneyNumber(this.value)) {
      // 			if(this.initRormat){
      // 				if(this.newVal){
      // 					this.money=this.newVal
      // 				}else{
      // 					this.money = this.value ? parseFloat((parseFloat(this.value) / Math.pow(10, this.data.decimals)).toFixed(this.data.decimals)) : 0;
      // 				}
      //             }else if (this.useOrigin) {
      // 				this.money = this.value;
      // 			} else {
      // 				this.money = this.value ? parseFloat((parseFloat(this.value) / Math.pow(10, this.data.decimals)).toFixed(this.data.decimals)) : 0;
      // 			}
      // 		} else {
      // 			this.money = this.value;
      // 		}
      // 	}
      // });
    },
    onInput(value) {
      let newVal;
      if (!this.useOrigin && regexMoneyNumber(value)) {
        newVal = value ? parseInt((parseFloat(value) * Math.pow(10, this.data.decimals)).toFixed(this.data.decimals)) : 0;
      } else {
        newVal = value;
      }
      this.newVal = newVal;
      const arr = value.split('.');
      if (arr[1]) {
        //解决 例如人民币时，输入框值为 1.12345 时。实际返回值是 1.1234 不一致
        arr[1] = '.' + arr[1].slice(0, this.data.decimals);
        this.money = arr[0] + arr[1];
      }
      this.$emit('input', newVal);
    },
    change(value) {
      let newVal;
      if (!this.useOrigin && regexMoneyNumber(value)) {
        newVal = value ? parseInt((parseFloat(value) * Math.pow(10, this.data.decimals)).toFixed(this.data.decimals)) : 0;
      } else {
        newVal = value;
      }
      this.newVal = newVal;
      this.$emit('change', newVal);
    },
    blur(e) {
      const value = e.target.value;
      let newVal;
      if (!this.useOrigin && regexMoneyNumber(value)) {
        newVal = value ? parseInt((parseFloat(value) * Math.pow(10, this.data.decimals)).toFixed(this.data.decimals)) : 0;
      } else {
        newVal = value;
      }
      this.newVal = newVal;
      this.$emit('blur', {
        e,
        value: newVal
      });
      this.$emit('update', newVal);
    }
  }
};
</script>
